import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "adm-card-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _mergeProps({ class: _ctx.classes }, _ctx.$attrs), [
    (_ctx.mediaSrc)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "adm-card-media",
          style: _normalizeStyle(_ctx.mediaStyleObject),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clickMedia')))
        }, null, 4))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 16))
}